import { parse } from "acorn";
import memoize from "lru-memoize";

export const memoParse = memoize(50)(parse);

export const detectMode = (text: string) =>
  text.length >= 2 && text[0] === "`" && text.indexOf("`", 1) === text.length - 1
    ? "jstl"
    : "javascript";
